// v0.6.12 — a server refusal, as a sentence an operator can act on.
//
// Operator, 2026-10-11: the freeze dialog showed "REQUIRED_INPUT_NOT_ENTERED"
// and a failed calculation showed the raw JSON payload — "makes no sense".
// Both catch sites picked the machine fields over the message the server
// already sends. This reads the message, and for the one refusal whose
// message is generic on purpose (it covers every country), names the boxes.
import { toErrorString } from "./errorMessage";

const countryName = (cc) => {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(cc) || cc;
  } catch {
    return cc;
  }
};

const pendingBox = (p) => {
  const label = p.label || "";
  const ref = p.box_ref ? `box ${p.box_ref}` : "";
  const what = label && ref ? `${label} (${ref})` : (label || ref || "a required box");
  return `${countryName(p.country)}: ${what}`;
};

export const serverErrorText = (detail, fallback = "Request failed") => {
  if (detail === null || detail === undefined || detail === "") return fallback;
  if (typeof detail === "string") return detail;
  if (detail.error === "REQUIRED_INPUT_NOT_ENTERED"
      && Array.isArray(detail.pending) && detail.pending.length) {
    return `Not entered yet — ${detail.pending.map(pendingBox).join("; ")}. `
      + "Open that country's return and give each a figure; 0 is fine, "
      + "with a reason.";
  }
  return toErrorString(detail) || fallback;
};

export default serverErrorText;
